module.exports = __webpack_public_path__ + "img/tips.5d9f554d.png";